class RenewalMessageController {
    constructor($scope, $http, $window, $timeout) {
        'ngInject';
        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.spinner = false;
        this.httpError = false;

        // Final Upload Statuses
        this.success = false;
        this.error = false;

        // Identifiers
        this.texareaID = '#renewalMessage';

        // Default Values
        this.errorMsg = '';
    }

    $onInit() {
        this.spinner = true;
        this.$timeout(() => {
            this.$http({
                url: '/api/chapterleader/GetCLPRenewalMessage',
                method: 'POST',
                data: { chapterId: this.chapterId }
            }).then((response) => {
                this.spinner = false;
                $(this.texareaID).val(response.data.RenewalMessage);
            }, (response) => {
                this.spinner = false;
                this.error = true;
                this.errorMsg = response;
            });
        }, 1000);
    }

    updateMessage() {
        this.spinner = true;
        this.success = false;
        this.error = false;
        var messageTxt = $(this.texareaID).val();
        this.$timeout(() => {
            this.$http({
                url: '/api/chapterleader/UploadCLPRenewalMessage',
                method: 'POST',
                data: {
                    chapterId: this.chapterId,
                    message: messageTxt
                }
            }).then((response) => {
                if(response.data.SuccessStatus) {
                    this.spinner = false;
                    this.success = true;
                } else {
                    this.spinner = false;
                    this.error = true;
                    this.errorMsg = response.data.ErrorStatus;
                }
            }, (response) => {
                this.spinner = false;
                this.error = true;
                this.errorMsg = response;
            });
        }, 1000);
    }
}

export default RenewalMessageController;



// WEBPACK FOOTER //
// ./src/app/angular/renewal-message/renewal-message.controller.js